import env from "./enviroment.json";
import "./callApi";
import { axiosget, axiospostjson, axiospost } from "./callApi";

const { URL, endpoints } = env;

export const Services = (callback) => {
  const url = URL.baseUrl + endpoints.services;
  axiosget(url, "", callback);
};
export const Subservices = (subservicesDetail, callback) => {
  const url = URL.baseUrl + endpoints.subservices;
  axiospostjson(url, subservicesDetail, "", callback);
};
export const login = (loginDetails, callback) => {
  const url = URL.baseUrl + endpoints.login;
  axiospostjson(url, loginDetails, "", callback);
};
export const Timeperiod = (loginDetails, callback) => {
  const url = URL.baseUrl + endpoints.timeperiod;
  axiospostjson(url, loginDetails, "", callback);
};
export const Subservicevariant = (loginDetails, callback) => {
  const url = URL.baseUrl + endpoints.subservicevariant;
  axiospostjson(url, loginDetails, "", callback);
};
export const Alladdressdetails = (token, callback) => {
  const url = URL.baseUrl + endpoints.alladdressdetails;
  axiosget(url, token, callback);
};
export const TotalPriceCalculation = (
  totalPriceCalculationDetails,
  callback
) => {
  const url = URL.baseUrl + endpoints.totalPriceCalculation;
  axiospostjson(url, totalPriceCalculationDetails, "", callback);
};
export const Nursingbooking = (nursingBookingDetail, token, callback) => {
  const url = URL.baseUrl + endpoints.nursebooking;
  axiospostjson(url, nursingBookingDetail, token, callback);
};
export const Locationdetails = (nursingBookingDetail, callback) => {
  const url = URL.baseUrl + endpoints.locationdetails;
  axiospostjson(url, nursingBookingDetail, "", callback);
};
export const Registration = (regDetail, callback) => {
  const url = URL.baseUrl + endpoints.registration;
  axiospostjson(url, regDetail, "", callback);
};
export const CheckServiceAvailability = (
  serviceAvailabilityDetails,
  callback
) => {
  const url = URL.baseUrl + endpoints.checkserviceavailability;
  axiospostjson(url, serviceAvailabilityDetails, "", callback);
};
export const Bookingdetails = (token, callback) => {
  const url = URL.baseUrl + endpoints.bookingdetails;
  axiosget(url, token, callback);
};

export const ProfileUpdate = (profileUpdateDetail, token, callback) => {
  const url = URL.baseUrl + endpoints.profileUpdate;
  axiospostjson(url, profileUpdateDetail, token, callback);
};
export const EmployeeDetails = (callback) => {
  const url = URL.baseUrl + endpoints.employeedetails;
  axiosget(url, "", callback);
};
export const Vendorlist = (callback) => {
  const url = URL.baseUrl + endpoints.vendorlist;
  axiosget(url, "", callback);
};
export const SubserviceVariantPrices = (
  subservicevariantpriceDetails,
  callback
) => {
  const url = URL.baseUrl + endpoints.subservicevariantprices;
  axiospostjson(url, subservicevariantpriceDetails, "", callback);
};
export const GetAddress = (token, addressId, callback) => {
  const url = URL.baseUrl + `${endpoints.getAddress}/${addressId}`;
  axiosget(url, token, callback);
};
export const UpdateAddresses = (updateAddressDetail, token, callback) => {
  const url = URL.baseUrl + endpoints.updateAddress;
  axiospostjson(url, updateAddressDetail, token, callback);
};
export const NewAddress = (newAddressDetail, token, callback) => {
  const url = URL.baseUrl + endpoints.newAddress;
  axiospostjson(url, newAddressDetail, token, callback);
};
export const cityDetails = (query, callback) => {
  const url = URL.baseUrl + endpoints.getCity + `?q=${query}`;
  axiosget(url, "", callback);
};

export const districtDetails = (query, callback) => {
  const url = URL.baseUrl + endpoints.getDistrict + `?q=${query}`;
  axiosget(url, "", callback);
};

export const stateDetails = (query, callback) => {
  const url = URL.baseUrl + endpoints.getState + `?q=${query}`;
  axiosget(url, "", callback);
};

export const Contactus = (contactus, callback) => {
  const url = URL.baseUrl + endpoints.contactus;
  axiospostjson(url, contactus, "", callback);
};

export const Hospital = (callback) => {
  const url = URL.baseUrl + endpoints.hospital;
  axiosget(url, "", callback);
};

export const Hospitalbooking = (hospitalBookingDetail, token, callback) => {
  const url = URL.baseUrl + endpoints.hospitalbooking;
  axiospostjson(url, hospitalBookingDetail, token, callback);
};

export const EquipmentList = (EquipementDetail, callback) => {
  const url = URL.baseUrl + endpoints.equipments;
  axiospostjson(url, EquipementDetail, "", callback);
};

export const MedicalEquipmentOrder = (medicalEquipmentOrderdetail, token, callback) => {
  const url = URL.baseUrl + endpoints.medicalEquipmentOrder;
  axiospostjson(url, medicalEquipmentOrderdetail, token, callback);
};

export const MedicineData = (callback) => {
  const url = URL.baseUrl + endpoints.medicines;
  axiosget(url, "", callback);
};

export const MedicineOrder = (medicineOrderdetail, token, callback) => {
  const url = URL.baseUrl + endpoints.medicineOrder;
  axiospostjson(url, medicineOrderdetail, token, callback);
};

export const EquipmentVendorDetails = (callback) => {
  const url = URL.baseUrl + endpoints.equipmentVendorDetails;
  axiosget(url, "", callback);
};

export const SurgeryList = (callback) => {
  const url = URL.baseUrl + endpoints.surgeryList;
  axiosget(url, "", callback);
}

export const SurgeryHospitals = (surgeryHospitals, callback) => {
  const url = URL.baseUrl + endpoints.surgeryHospitals;
  axiospostjson(url, surgeryHospitals, "", callback);
};

export const SurgeryDoctors = (surgeryDoctors, callback) => {
  const url = URL.baseUrl + endpoints.surgeryDoctors;
  axiospostjson(url, surgeryDoctors, "", callback);
};

export const Surgerybooking = (surgerybookingdetail, token, callback) => {
  const url = URL.baseUrl + endpoints.surgerybooking;
  axiospostjson(url, surgerybookingdetail, token, callback);
};